module.exports = "<!-- ============================================================== -->\n<!-- Only router without any element -->\n<!-- ============================================================== -->\n<mat-sidenav-container>\n  <router-outlet></router-outlet>\n</mat-sidenav-container>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/blank/blank.component.html
// module id = ./src/app/layouts/blank/blank.component.html
// module chunks = main